import React from 'react'

import { AccounHeader } from 'scenes/account/AccountMainMenu'
import CompositionBaseScene from 'scenes/compositions/base'


export default function CompositionIndex(props) {

  const query = [
    'compositions',
    'mine',
  ]

  return (
    <>
      <AccounHeader />
      <CompositionBaseScene
        baseRedirect='/account/compositions'
        baseRedirectEmpty='/account'
        query={query}
      />
    </>
  )
}
